<template>
  <div>
    <Dialog
      width="860px"
      :background="
        createRenderType == 'mobile' && !props.item?.song_id
          ? 'linear-gradient(180deg, rgba(189, 255, 151, 0.3) 0%, rgba(189, 255, 151, 0) 100%),black'
          : null
      "
      :height="createRenderType == 'mobile' ? '100%' : '644px'"
      titleAlign="left"
      :title="$$t('editor.track_stem')"
      :visible="renderData.visible"
      :questionClick="null"
      @close="closeDialog"
      mobileRenderType="drawerDialog"
      customClass="track-stem-dialog"
    >
      <div
        class="track-stem-dialog-container"
        :class="{
          [`track-stem-dialog-container-${createRenderType}`]: true,
        }"
      >
        <div class="track-stem-dialog-edit-box">
          <div class="track-stem-dialog-media-box">
            <div
              class="track-stem-dialog-media-upload"
              v-if="renderData.editMode == 'upload'"
            >
              <AudioDragUpload
                pointTypePrefix="track_stem"
                :uploadDescription="$$t('editor.splitter_description')"
                @initEditData="doInitEditData"
                @syncUploadState="doSyncUploadState"
              ></AudioDragUpload>
            </div>
            <div
              class="track-stem-dialog-media-processing"
              v-if="renderData.editMode == 'processing'"
            >
              <div class="redm-processing-loading-box">
                <div class="redm-processing-loading rotate-loading"></div>
                <div class="redm-processing-loading-ico flex-center">
                  <i class="icon"> </i>
                </div>
              </div>
              <div class="processing-text">
                {{ $$t("editor.audio_edit_data_processing") }}
              </div>
            </div>
            <div
              class="track-stem-dialog-media-processfailed"
              v-if="renderData.editMode == 'processfailed'"
            >
              <div class="extend-processing-processfailed-ico"></div>
              <div class="track-stem-dialog-media-processfailed-text">
                {{ $$t("editor.get_editing_data_failed") }}
              </div>
              <div class="track-stem-dialog-media-processfailed-button">
                <Button
                  @click="onRetryClick"
                  :renderStyle="{
                    '--padding': '0',
                    '--width': '100%',
                    '--height': '32px',
                    '--borderRadius': '48px',
                    '--background': 'rgba(255, 255, 255, 0.2)',
                    '--fontColor': '#fff',
                    '--fontSize': '14px',
                    '--fontWeight': 'normal',
                    '--border': 'none',
                    '--backgroundHover': 'rgba(255, 255, 255, 0.3)',
                    '--fontColorHover': '#fff',
                  }"
                >
                  <span class="fn-inline">{{ $$t("create.retry") }}</span>
                </Button>
              </div>
            </div>
            <div
              v-if="renderData.editMode == 'edit'"
              class="track-stem-dialog-media-wave"
            >
              <MusicWave
                ref="refClipFixedDuration"
                :waveformData="renderData.waveformData"
                :label="$$t('create.select_clip')"
                :url="getObjectStorageFullUrl(renderData.playUrl)"
                :duration="renderData.audioDuration"
                :hideChangeProgress="hideChangeProgress"
                :hideRemove="hideRemove"
                @remove="doRemove"
                @syncProgress="syncProgress"
                @doTogglePlay="doTogglePlay"
              ></MusicWave>
            </div>
          </div>
          <div class="track-stem-dialog-stems-box">
            <div
              class="flex1 flex-center tip"
              v-if="!renderData.stems && !trackLoading"
            >
              {{ $$t("editor.stems_will_display_here") }}
            </div>
            <div
              v-if="!renderData.stems && trackLoading"
              :class="`${createRenderType}-track-skeleton`"
            >
              <div class="item" v-for="i in 4" :key="i"></div>
            </div>
            <div
              class="stems-wave-box flex1"
              v-if="renderData.stems && !trackLoading"
            >
              <MultiTrackWaveform
                :data="stemList"
                :progress="progress"
                :duration="renderData.audioDuration"
                @changeTrackProgress="changeTrackProgress"
                @handleSolo="handleSolo"
                @handleDownOneTrack="handleDownOneTrack"
              ></MultiTrackWaveform>
            </div>
          </div>
        </div>
        <div class="track-stem-dialog-button-box">
          <CreditsButton
            v-if="!renderData.stems"
            :buttonText="$$t('editor.track_stem_btn')"
            :disabled="renderData.disabledSubmit"
            :loading="trackLoading"
            @onClick="handleTrackStem"
          ></CreditsButton>
          <Button
            v-else
            class="download-button"
            :loading="downloadLoading"
            :renderStyle="{
              '--padding': '0',
              '--width': '100%',
              '--height': '48px',
              '--borderRadius': '48px',
              '--background':
                'linear-gradient(97deg, rgba(79, 222, 255, 1) 0%, rgba(230, 117, 255, 1) 99%)',
              '--fontColor': '#000',
              '--fontSize': '16px',
              '--fontWeight': '500',
              '--border': 'none',
              '--backgroundHover':
                'linear-gradient(97deg, rgba(79, 222, 255, 0.75) 0%, rgba(230, 117, 255, 0.75) 99%)',
              '--fontColorHover': '#000',
            }"
            @click="downloadAllData"
          >
            <span>{{ $$t("editor.download_all_steam_track") }}</span>
          </Button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import {
  defineProps,
  defineEmits,
  reactive,
  watch,
  ref,
  getCurrentInstance,
  onMounted,
  onUnmounted,
} from "vue"
import { useRouter } from "vue-router"
import tools from "@/utils/tools.js"
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js"
import apiEditor from "@/api/api/apiEditor"
import feedListApi from "@/api/api/feedListApi.js"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
import useUserDataStore from "@/store/userDataStore.js"
import useFeedListStore from "@/store/create/feedListDataStore.js"
import { openCreditDialog } from "@/page/credits/addCreditsDialog.js"
import message from "@/components/functionCallComponent/message/message.js"
import Button from "@/components/basic/button/Button.vue"
import CreditsButton from "../component/creditsButton.vue"
import AudioDragUpload from "../component/audioDragUpload.vue"
import MusicWave from "./components/musicWave.vue"
import MultiTrackWaveform from "./components/multiTrackWaveform.vue"

const router = useRouter()
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties
const { $$t } = globalProperties?.$i18n;
const createLayoutStore = useCreateLayoutStore()
const userDataStore = useUserDataStore()
const { createRenderType } = storeToRefs(createLayoutStore)
const feedListDataStore = useFeedListStore()

const appContext = getCurrentInstance()?.appContext

const emits = defineEmits(["update:visible"])
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
})

const refClipFixedDuration = ref(null)
const renderData = reactive({
  visible: true,
  editMode: "upload", // "upload", "processing","edit", "processfailed"
  stems: false,
  playUrl: "", // 播放的url
  url: "",
  waveformData: null,
  audioDuration: 0,
  title: "",
  disabledSubmit: true,
  song_id: "",
  outer_song_id: "",
})
const progress = ref(0)
const stemList = ref([])
const trackLoading = ref(false)
const downloadLoading = ref(false)
const hideChangeProgress = ref(false)
const hideRemove = ref(false)
let userOpPlayState = false

const stateData = {
  parseDataParams: null,
  curPlayerData: null,
}

watch(
  () => {
    return props.visible
  },
  (val) => {
    renderData.visible = props.visible
    if (val) {
      globalProperties.logCustomEvent("create_audio_edit_tab_stare_show", {
        tab_stare: "track_stem",
      })
    }
  },
  {
    immediate: true,
  }
)
watch(
  () => {
    return renderData.visible
  },
  () => {
    emits("update:visible", renderData.visible)
  }
)

const closeDialog = () => {
  if (renderData.stems) {
    message.info({
      content: $$t("editor.splitter_delete_tip"),
      postion: "top",
      duration: 8000,
    })
  } else {
    if (trackLoading.value) {
      message.info({
        content: $$t("editor.splittering_tip"),
        postion: "top",
        duration: 8000,
      })
    }
  }
  renderData.visible = false
  renderData.editMode = "upload"
  renderData.waveformData = null
  renderData.stems = false
}

const doRemove = () => {
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer
      ?.currentUrl
  )
  if (renderData.stems) {
    message.error({
      content: $$t("editor.splitter_delete_tip"),
      postion: "top",
      duration: 8000,
    })
  }
  renderData.editMode = "upload"
  renderData.stems = false
  renderData.disabledSubmit = true
  trackLoading.value = false
}

const doInitEditData = async (data) => {
  doInitEditFile(data, true)
}

const doInitEditFile = async (data) => {
  renderData.editMode = "processing"
  stateData.parseDataParams = {
    resource: data.linkUrl,
    source_type: data.source_type,
    cos_url: data?.cos_url,
    duration_milliseconds: data?.duration_milliseconds,
    title: data?.title,
    check_mute_duration: false,
  }
  return new Promise((resolve, reject) => {
    apiEditor
      .parseAudioData(data)
      .then((res) => {
        if (res.code == 200) {
          renderData.waveformData = res.data.waves
          renderData.audioDuration = res.data.duration_milliseconds / 1000
          renderData.url = res.data.mp3_url
          renderData.playUrl = res.data.mp3_url + "?type=trak_stem"
          renderData.title = res.data.title
          renderData.editMode = "edit"
          renderData.disabledSubmit = false
          renderData.outer_song_id = res.data.id
        } else if (res.code == 6316) {
          message.error({
            position: "top",
            content: $$t("create.song_title_audit_failed"),
          })
          renderData.editMode = "upload"
        } else if (res.code == 6346) {
          message.error({
            content: $$t("editor.check_mute_duration_warning"),
            positon: "top",
          })
          renderData.editMode = "upload"
        } else {
          message.error({
            content: $$t("editor.get_editing_data_failed_message"),
            positon: "top",
          })
          renderData.editMode = "processfailed"
        }
      })
      .catch((err) => {
        message.error({
          content: $$t("editor.get_editing_data_failed_message"),
          positon: "top",
        })
        renderData.editMode = "processfailed"
        reject(err)
      })
  })
}

const onRetryClick = () => {
  doInitEditFile(stateData.parseDataParams)
}

const handleTrackStem = () => {
  if (renderData.disabledSubmit) return
  globalProperties.logCustomEvent("track_stem_button_click", {
    tab_stare: "track_stem",
  })
  trackLoading.value = true
  hideRemove.value = true
  apiEditor
    .separateSong({
      cos_url: renderData.url,
      title: renderData.title,
      mode: 2, // 2-分轨
      duration_milliseconds: stateData.parseDataParams.duration_milliseconds,
      outer_song_id: renderData.outer_song_id,
    })
    .then((res) => {
      if (!res) return
      if (res.code == 200) {
        renderData.stems = true
        renderData.song_id = res.data?.song_id
        stemList.value = res.data?.list
        feedListDataStore.insertGenerateCard(res.data?.feed)
      } else if (res.code == 6335) {
        router.push({
          name: "subscribe",
          membership_source1: "editor",
          membership_source2: "track_stem",
        })
      } else if (res.code == 6310) {
        openCreditDialog()
      } else if (res.code == 6315) {
        message.info({
          position: "top",
          content: $$t("create.song_state_auditing_failed"),
        })
      } else {
        message.error({
          position: "top",
          content: $$t("editor.track_stem_fail"),
        })
      }
    })
    .finally(() => {
      userDataStore.refreshUserAccount()
      trackLoading.value = false
      hideRemove.value = false
    })
}

// // 拖动进度条
// const changeProgress = (progressValue) => {
//   // progress.value = progressValue;
// };

// 进度改变
const syncProgress = (progressValue) => {
  progress.value = progressValue
}

// track改变进度
const changeTrackProgress = (progressValue) => {
  progress.value = progressValue
  refClipFixedDuration.value?.changeProgress(progressValue / 100)
}

const waitForAudioCanPlay = (audio) => {
  return new Promise((resolve) => {
    if (!audio) return resolve()
    if (audio.readyState >= 3) return resolve()
    const onCanPlay = () => {
      audio.removeEventListener("canplay", onCanPlay)
      resolve()
    }
    audio.addEventListener("canplay", onCanPlay)
  })
}

const doTogglePlay = (isPlay) => {
  userOpPlayState = isPlay
}

// 单轨道solo
const handleSolo = async (url, title) => {
  if (url) {
    globalProperties.logCustomEvent("track_stem_button_click", {
      tab_stare: "solo_play",
      membership_source1: title,
    })
  }
  hideChangeProgress.value = true
  const renderProgress = progress.value
  const isPlay =
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer
      ?.players[getObjectStorageFullUrl(renderData.playUrl)]?.isPlaying
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(
    getObjectStorageFullUrl(renderData.playUrl)
  )
  renderData.playUrl = (url || renderData.url) + "?type=trak_stem"
  stateData.curPlayerData =
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registerPlayUrl(
      getObjectStorageFullUrl(renderData.playUrl),
      {
        duration: renderData.audioDuration,
        personalizedConfig: {
          loop: false,
          autoToStartIfNotCurrent: false,
          canSeekNotCurrent: true,
        },
      }
    )
  console.log(
    isPlay,
    renderData.playUrl,
    renderData.audioDuration,
    renderProgress
  )
  await waitForAudioCanPlay(stateData.curPlayerData.audio)

  if (isPlay || userOpPlayState) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.play(
      getObjectStorageFullUrl(renderData.playUrl),
      true,
      (renderData.audioDuration * renderProgress) / 100
    )
  } else {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.seek(
      getObjectStorageFullUrl(renderData.playUrl),
      renderProgress / 100
    )
  }

  nextTick().then(() => {
    hideChangeProgress.value = false
  })
}

// 下载单轨
const handleDownOneTrack = (item) => {
  globalProperties.logCustomEvent("track_stem_button_click", {
    tab_stare: "download_one",
    source:
      stateData.parseDataParams?.source_type == 1
        ? "youtube_link_upload"
        : "file_upload",
    membership_source1: item.title,
  })
  feedListApi
    .getSongAuditState({
      song_id: renderData.song_id,
    })
    .then((res) => {
      if (res.code == 200) {
        message.info({
          position: "top",
          content: $$t("editor.downloading_stem", "", {
            title:
              $$t(`editor.${item?.title}`) +
              "." +
              tools.getFileExtension(item.url),
          }),
        })
        tools
          .downLoadAtag({
            useAlink: true,
            href: getObjectStorageFullUrl(item.url),
            fileName:
              $$t(`editor.${item?.title}`) +
              "." +
              tools.getFileExtension(item.url),
          })
          .then((res) => {})
          .catch((err) => {})
      } else {
        if (res.code == 6314) {
          message.info({
            position: "top",
            content: $$t("create.song_state_auditing"),
          })
        } else if (res.code == 6335) {
          message.error({
            content: $$t("editor.subscripe_level_not_met"),
            position: "top",
          })
        } else if (res.code == 6315) {
          message.info({
            position: "top",
            content: $$t("create.song_state_auditing_failed"),
          })
        }
      }
    })
    .catch(() => {
      message.info({
        position: "top",
        content: $$t("create.get_song_state_failed"),
      })
    })
}

// 下载全部分轨
const downloadAllData = () => {
  downloadLoading.value = true
  globalProperties.logCustomEvent("track_stem_button_click", {
    tab_stare: "download_all_steam_track",
    source:
      stateData.parseDataParams?.source_type == 1
        ? "youtube_link_upload"
        : "file_upload",
    membership_source1: stemList.value.map((item) => item.title).join(","),
  })
  feedListApi
    .feedCardDownloadQuery({
      song_id: renderData.song_id,
      t: 2,
    })
    .then((res) => {
      if (res.code == 200) {
        message.info({
          position: "top",
          content: $$t("create.downloading_stem_audio"),
        })
        userDataStore.refreshUserAccount()
        tools
          .downLoadAtag({
            useAlink: true,
            href: getObjectStorageFullUrl(res.data.oss_key),
            fileName:
              renderData.title + "." + tools.getFileExtension(res.data.oss_key),
          })
          .then((res) => {})
      } else if (res.code == 6314) {
        message.info({
          position: "top",
          content: $$t("create.song_state_auditing"),
        })
      } else if (res.code == 6315) {
        message.info({
          position: "top",
          content: $$t("create.song_state_auditing_failed"),
        })
      } else if (res.code == 6335) {
        message.error({
          content: $$t("editor.subscripe_level_not_met"),
          position: "top",
        })
      } else {
        message.error({
          position: "top",
          content: $$t("create.downloading_failed"),
        })
      }
    })
    .catch((err) => {
      message.error({
        position: "top",
        content: $$t("create.downloading_failed"),
      })
    })
    .finally(() => {
      downloadLoading.value = false
    })
}
const mediaSessionPlayStateChange = (isPlay) => {
  if (
    getObjectStorageFullUrl(renderData.playUrl) ==
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer
      ?.currentUrl
  ) {
    userOpPlayState = isPlay
  }
}

onMounted(() => {
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registGlobalListener(
    "mediaSessionPlayStateChange",
    mediaSessionPlayStateChange
  )
})

onUnmounted(() => {
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releasePlayer(
    stateData.curPlayerData
  )
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releaseGlobalListener(
    "mediaSessionPlayStateChange",
    mediaSessionPlayStateChange
  )
})
</script>
<style lang="scss">
@keyframes opacityAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.pc-track-skeleton {
  padding: 20px 20px 0;
  animation: opacityAnimation 1.8s infinite;
  .item {
    width: 100%;
    height: 56px;
    background: rgb(255, 255, 255, 0.1);
    margin-bottom: 6px;
    border-radius: 8px;
    &:last-of-type {
      margin-bottom: 0px;
    }
  }
}

.mobile-track-skeleton {
  padding: 0;
  animation: opacityAnimation 1.8s infinite;
  .item {
    width: 100%;
    height: 56px;
    background: rgb(255, 255, 255, 0.1);
    margin-bottom: 6px;
    border-radius: 8px;
    &:last-of-type {
      margin-bottom: 0px;
    }
  }
}
</style>
<style lang="scss" scoped>
.track-stem-dialog {
  &-container {
    color: #fff;
    padding: 13px 40px 40px 40px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  &-edit-box {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 0;

    .track-stem-dialog-media-box {
      border-radius: 16px 16px 0 0;
      background: rgba(148, 173, 255, 0.2);
      .track-stem-dialog-media-wave {
        padding-bottom: 10px;
        // border-radius: 16px;
      }
      .track-stem-dialog-media-processing {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 196px;
        padding: 20px 0 16px;
        .redm-processing-loading-box {
          width: 100px;
          height: 100px;
          position: relative;

          .redm-processing-loading {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background: conic-gradient(
              from 180deg at 50% 50%,
              rgba(148, 173, 255, 0.28) 0deg,
              rgba(148, 173, 255, 0.8) 54deg,
              rgba(148, 173, 255, 0.2) 95deg,
              rgba(148, 173, 255, 0.1) 136deg,
              rgba(148, 173, 255, 0.28) 178deg,
              rgba(148, 173, 255, 0.8) 236deg,
              rgba(148, 173, 255, 0.2) 279deg,
              rgba(148, 173, 255, 0.1) 321deg,
              rgba(148, 173, 255, 0.28) 360deg,
              rgba(148, 173, 255, 0.8) 414deg
            );
          }
          .redm-processing-loading-ico {
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            i {
              height: 100%;
              width: 100%;
              background: url(@/assets/img/editor/upload-drag-loading-ico.png);
              background-size: 100% 100%;
            }
          }
        }
        .processing-text {
          font-family: HarmonyOS Sans SC;
          font-size: 14px;
          font-weight: normal;
          line-height: normal;
          color: #ffffff;
          margin: 16px 0 0 0;
        }
      }
      .track-stem-dialog-media-processfailed {
        padding: 19px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .extend-processing-processfailed-ico {
          height: 80px;
          width: 80px;
          background: url(@/assets/img/editor/upload-processing-failed-ico.png);
          background-size: 100% 100%;
        }
        .track-stem-dialog-media-processfailed-text {
          font-family: HarmonyOS Sans SC;
          font-size: 16px;
          font-weight: normal;
          line-height: 22px;
          color: #ffffff;
          margin: 12px 12px;
        }
        .track-stem-dialog-media-processfailed-button {
          width: 140px;
        }
      }
    }

    .track-stem-dialog-stems-box {
      margin: 1px 0 0 0;
      height: 0;
      flex: 1;
      border-radius: 0 0 16px 16px;
      background: rgba(148, 173, 255, 0.2);
      flex-shrink: 0;
      .tip {
        height: 100%;
        opacity: 0.5;
        font-size: 16px;
        margin-top: -4px;
      }
      .stems-wave-box {
        padding: 20px 20px 0;
      }
    }
  }
  &-button-box {
    margin: 20px 0 0 0;
  }
  .download-button {
    :deep(.el-button .el-icon.is-loading) {
      background-image: url("@/assets/img/loading-mini-white-3x.png") !important;
    }
  }
}
.track-stem-dialog {
  .track-stem-dialog-container-mobile {
    padding: 16px;
    .track-stem-dialog-button-box {
      margin: 16px 0 0 0;
    }
    .track-stem-dialog-edit-box {
      .track-stem-dialog-media-box {
        border-radius: 16px;
        padding-bottom: 0;
        .track-stem-dialog-media-processing {
          height: 160px;
          padding: 22px 0 16px;
          .redm-processing-loading-box {
            width: 80px;
            height: 80px;
          }
          .processing-text {
            font-family: HarmonyOS Sans SC;
            font-size: 14px;
            font-weight: normal;
            line-height: normal;
            color: #ffffff;
            margin: 12px 0 0 0;
          }
        }
      }
      .track-stem-dialog-stems-box {
        background: transparent;
        padding: 12px 0 0;

        .stems-wave-box {
          padding: 0;
        }
      }
    }
  }
}
</style>
